import { computed, Directive, input } from '@angular/core';
import { hlm } from '@spartan-ng/ui-core';

import type { ClassValue } from 'clsx';

@Directive({
    selector: '[hlmDialogClose],[brnDialogClose][hlm]',
    standalone: true,
    host: {
        '[class]': '_computedClass()'
    }
})
export class HlmDialogCloseDirective {
    public readonly userClass = input<ClassValue>('', { alias: 'class' });
    protected _computedClass = computed(() =>
        hlm(
            'tw-absolute tw-right-4 tw-top-4 tw-rounded-sm tw-opacity-70 tw-ring-offset-background tw-transition-opacity hover:tw-opacity-100 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2 disabled:tw-pointer-events-none data-[state=open]:tw-bg-accent data-[state=open]:tw-text-muted-foreground',
            this.userClass()
        )
    );
}
